module.exports = __webpack_public_path__ + "img/tutorial-live-thumb.94d91ab7.png";